module.exports = __webpack_public_path__ + "media/images/icon__compete-6feba76e161c011e434e9626e0d4aadf.png";